<template>
    <div class="admin-user">
        <el-select v-model="adminUser" filterable multiple clearable placeholder="请选择" :size="size" @click.native="loadAdminUser" style="width: 100%;" @change="$emit('choosed',adminUser)">
            <el-option v-for="item in options" :key="item.id" :label="item.username" :value="item.id">
            </el-option>
        </el-select>
    </div>
</template>

<script>
export default {
    name: 'adminUser',
    props: {
        size: {
            type: String,
            default: 'mini'
        },
        load: {
            type: Boolean,
            default: false
        },
        ids: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            adminUser: '',
            options: []
        }
    },
    methods: {
        loadAdminUser() {
            this.$axios.get('api/api3_common_get_admin_user').then(({data}) => {
                let {code,data:x1} = data
                if (code === 200) {
                    this.options = x1
                }
            }).catch()
        }
    },
    mounted() {
        if (this.load) {
            this.adminUser = this.ids
            this.loadAdminUser()
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/commonReform/AdminUser.vue